import {StapleFoodEntity} from "./config/StapleFoodConfig";
import O1HD from "../../../../engines/gameEngine";
import redPacketChallege from "../../../spendMode/prefab/redPacketChallenge/redPacketChallenge";
import data_control from "../../../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;
/**
 * 人 脚本
 */
@ccclass
export default class HumanScript extends cc.Component {

    @property({type:sp.Skeleton,displayName:"老头"})
    hmLaoTouSp : sp.Skeleton = null;
    @property({type:sp.Skeleton,displayName:"奶奶"})
    hmNaiNaiSp : sp.Skeleton = null;
    @property({type:sp.Skeleton,displayName:"乞丐"})
    hmQiGaiSp : sp.Skeleton = null;
    @property({type:sp.Skeleton,displayName:"乞丐杀马特"})
    hmQgSmtSp : sp.Skeleton = null;
    @property({type:sp.Skeleton,displayName:"强盗"})
    hmQiangDaoSp : sp.Skeleton = null;
    @property({type:sp.Skeleton,displayName:"富婆"})
    hmFpSp : sp.Skeleton = null;

    @property({type:cc.Label})
    lbLaoTouPrice : cc.Label = null;
    @property(cc.Label)
    lbLaoTouName : cc.Label = null;
    @property(cc.Label)
    lbNaiNaiPrice : cc.Label = null;
    @property(cc.Label)
    lbNaiNaiName : cc.Label = null;
    @property(cc.Label)
    lbQiGaiPrice : cc.Label = null;
    @property(cc.Label)
    lbQiGaiName : cc.Label = null;
    @property(cc.Label)
    lbQgSmtPrice : cc.Label = null;
    @property(cc.Label)
    lbQgSmtName : cc.Label = null;
    @property(cc.Label)
    lbTalkMsg : cc.Label = null;


    @property(cc.Label)
    lbQdName : cc.Label = null;
    @property(cc.Label)
    lbQdMsg : cc.Label = null;
    @property(cc.Label)
    lbFpName : cc.Label = null;
    @property(cc.Label)
    lbFpMsg : cc.Label = null;


    private mStartIndex : number = 0;
    private mCompleteCallBack ;
    private mTalkMsg : string ;
    onLoad () {
        O1HD.on( "HumanScript.humanEnter" , this.humanEnter , this );
        O1HD.on( "HumanScript.humanOut" , this.humanOut , this );
        O1HD.on( "HumanScript.humanPutPrice" , this.humanPutPrice , this );
    }

    start () {
        this.mStartIndex = Math.floor( Math.random() * 6 );
    }

    /**
     * 人物进场
     */
    humanEnter( stapleFoodEntity : StapleFoodEntity , talkMsg : string , completeCallBack ){
        this.mStartIndex++;
        this.mCompleteCallBack = completeCallBack;
        if ( this.mStartIndex > 5 ) {
            this.mStartIndex = 0;
        }
        let spNode : sp.Skeleton = this._getSpNode( this.mStartIndex );
        // this._initStatus( spNode );
        if ( spNode ) {
            spNode.setAnimation( 0 , "Walk" , true );
            spNode.node.x = 547;
            cc.tween( spNode.node )
                .to(0.8,{ x : 240 })
                .call(()=>{
                    spNode.setAnimation( 0, "Idle" , false );
                    this._talk( talkMsg );
                })
                .start();
        }
    }

    private _initStatus( spNode : sp.Skeleton ){
        this.scheduleOnce(()=>{
            if ( this.mStartIndex == 2 ) {
                spNode.setSkin("Nomal");
            }else{
                spNode.setSkin("Normal");
            }
            spNode.setToSetupPose();
        });
        this.lbLaoTouName.node.active = false;
        this.lbLaoTouPrice.node.active = false;
        this.lbNaiNaiName.node.active = false;
        this.lbNaiNaiPrice.node.active = false;
        this.lbQiGaiName.node.active = false;
        this.lbQiGaiPrice.node.active = false;

        this.lbQgSmtName.node.active = false;
        this.lbQgSmtPrice.node.active = false;
        this.lbQdName.node.active = false;
        this.lbQdMsg.node.active = false;
        this.lbFpName.node.active = false;
        this.lbFpMsg.node.active = false;
    }

    /**
     * 人物离场
     */
    humanOut( smileFlag : number , completeCallBack){
        this.mCompleteCallBack = completeCallBack;
        let spNode : sp.Skeleton = this._getSpNode( this.mStartIndex );
        this._initStatus( spNode );
        if ( spNode ) {
            if ( smileFlag == 1 ) {
                spNode.setAnimation( 0 , "Walk_Happy" , true );
            }else if ( smileFlag == 2 ){
                spNode.setAnimation( 0 , "Walk_Angry" , true );
            }else{
                spNode.setAnimation( 0 , "Walk" , true );
            }
            cc.tween( spNode.node )
                .by(1,{ x : -800 })
                .call(()=>{
                    spNode.node.active = false;
                    this.mCompleteCallBack && this.mCompleteCallBack();
                })
                .start();
        }
    }

    /**
     * 人物报价
     */
    humanPutPrice( price : number , talkMsg : string , smileFlag : number , completeCallBack ){
        this.mCompleteCallBack = completeCallBack;
        let judgeIndex = this.mStartIndex;
        let spNode : sp.Skeleton = this._getSpNode( this.mStartIndex );
        if ( spNode ) {
            this.scheduleOnce(()=>{
               spNode.setSkin("JuPai");
               spNode.setToSetupPose();
                switch ( judgeIndex ) {
                    case 0:
                        this.lbLaoTouName.node.active = true;
                        this.lbLaoTouPrice.node.active = true;
                        this.lbLaoTouPrice.string = `${data_control.getNumberFormat( price , 2 )}`;
                        break;
                    case 1:
                        this.lbNaiNaiName.node.active = true;
                        this.lbNaiNaiPrice.node.active = true;
                        this.lbNaiNaiPrice.string = `${data_control.getNumberFormat( price , 2 )}`;
                        break;
                    case 2:
                        this.lbQiGaiName.node.active = true;
                        this.lbQiGaiPrice.node.active = true;
                        this.lbQiGaiPrice.string = `${data_control.getNumberFormat( price , 2 )}`;
                        break;
                    case 3:
                        this.lbQgSmtName.node.active = true;
                        this.lbQgSmtPrice.node.active = true;
                        this.lbQgSmtPrice.string = `${data_control.getNumberFormat( price , 2 )}`;
                        break;
                    case 4:
                        this.lbQdName.node.active = true;
                        this.lbQdMsg.node.active = true;
                        this.lbQdMsg.string = `${data_control.getNumberFormat( price , 2 )}`;
                        break;
                    case 5:
                        this.lbFpName.node.active = true;
                        this.lbFpMsg.node.active = true;
                        this.lbFpMsg.string = `${data_control.getNumberFormat( price , 2 )}`;
                        break;
                }
            });
            //先举牌 报价
            spNode.setAnimation( 0 ,"JuPai", false );
            spNode.setCompleteListener(()=>{
                spNode.setCompleteListener(()=>{});
                //报价完成以后开始说话
                if ( smileFlag == 1 ) {
                    spNode.setAnimation( 0 , "Idle_Happy" , false );
                }else if ( smileFlag == 2 ){
                    spNode.setAnimation( 0 , "Idle_Angry" , false );
                }else{
                    spNode.setAnimation( 0 , "Idle" , false );
                }
                this._talk( talkMsg );
            });
        }
    }

    /**
     * 获取 骨骼节点
     */
    private _getSpNode( judgeIndex : number ) : sp.Skeleton {
        let spNode : sp.Skeleton;
        switch ( judgeIndex ) {
            case 0:
                this.hmLaoTouSp.node.active = true;
                spNode = this.hmLaoTouSp;
                break;
            case 1:
                this.hmNaiNaiSp.node.active = true;
                spNode = this.hmNaiNaiSp;
                break;
            case 2:
                this.hmQiGaiSp.node.active = true;
                spNode = this.hmQiGaiSp;
                break;
            case 3:
                this.hmQgSmtSp.node.active = true;
                spNode = this.hmQgSmtSp;
                break;
            case 4:
                this.hmQiangDaoSp.node.active = true;
                spNode = this.hmQiangDaoSp;
                break;
            case 5:
                this.hmFpSp.node.active = true;
                spNode = this.hmFpSp;
                break;
            default:
                this.hmLaoTouSp.node.active = true;
                spNode = this.hmLaoTouSp;
                break;
        }
        return spNode;
    }

    /**
     * 说话
     */
    private _talk ( msg : string ) {
        this.lbTalkMsg.node.parent.active = true;
        this.lbTalkMsg.string = ``;
        this.mTalkMsg = msg;
        this._talkFinish();
    }

    private callBack ;

    /**
     * 说 话 完
     */
    private _talkFinish(  ){
        if ( this.lbTalkMsg.string.length >= this.mTalkMsg.length ){
            this.callBack = ()=>{
                this.mCompleteCallBack && this.mCompleteCallBack();
                this.lbTalkMsg.node.parent.active = false;
            };
            this.scheduleOnce( this.callBack,1 );
            return;
        }
        this.lbTalkMsg.string = `${ this.mTalkMsg.substr( 0 , this.lbTalkMsg.string.length + 1 ) }`;
        this.scheduleOnce(()=>{
            this._talkFinish();
        },0.1 );
    }

}
